import { render, staticRenderFns } from "./CommunicationEmailNew.vue?vue&type=template&id=06d58e22&"
import script from "./CommunicationEmailNew.vue?vue&type=script&lang=js&"
export * from "./CommunicationEmailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports